export const FETCH_AUDIT_BREAKDOWN_STARTED = "FETCH_AUDIT_BREAKDOWN_STARTED";
export const FETCH_AUDIT_BREAKDOWN_SUCCEDED = "FETCH_AUDIT_BREAKDOWN_SUCCEDED";
export const FETCH_AUDIT_BREAKDOWN_FAILED = "FETCH_AUDIT_BREAKDOWN_FAILED";
